import React from "react";

import { DateRange } from "react-day-picker";

import { format } from "date-fns";
import { es } from "date-fns/locale";
import { Calendar } from "lucide-react";

import { Button } from "~/components/ui/button";
import { Calendar as CalendarComponent } from "~/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "~/components/ui/popover";

interface DateRangeFilterProps {
  dateRange: DateRange;
  setDateRange: (range: DateRange) => void;
}

const DateRangeFilter: React.FC<DateRangeFilterProps> = ({
  dateRange,
  setDateRange,
}) => {
  const handleDateRangeChange = (range: DateRange | undefined) => {
    setDateRange(range || { from: undefined, to: undefined });
  };
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" className="rounded-full">
          <Calendar className="mr-2 h-4 w-4" />
          {dateRange.from ? (
            dateRange.to ? (
              <>
                {format(dateRange.from, "MMM d", { locale: es })} -{" "}
                {format(dateRange.to, "MMM d, yyyy", { locale: es })}
              </>
            ) : (
              format(dateRange.from, "MMM d, yyyy", { locale: es })
            )
          ) : (
            "Rango de Fechas"
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="end">
        <CalendarComponent
          initialFocus
          mode="range"
          defaultMonth={dateRange.from}
          selected={dateRange}
          onSelect={handleDateRangeChange}
          numberOfMonths={2}
          className="pointer-events-auto p-3"
          locale={es}
          weekStartsOn={1}
        />
        <div className="flex items-center justify-between border-t border-border p-3">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setDateRange({ from: undefined, to: undefined })}
          >
            Limpiar
          </Button>
          {/* Note: Apply button removed as date changes are applied automatically via onSelect */}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default DateRangeFilter;
